<template>
  <div class="edit-menu">
    <div class="toggle">
      <button
        class="btn"
        :title="buttonTitle"
        :class="{ disabled: !isActive }"
        @click="toggleIsOpen"
      >
        <fa :icon="['fas', 'pen']" />
      </button>
    </div>

    <div class="edit-menu__slot" :class="{ open: isOpen }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      isOpen: "draggable/getIsMenuOpen"
    }),

    buttonTitle() {
      return this.isActive
        ? "Toggle Edit Menu"
        : "To edit, select a tag/element and click here";
    }
  },

  methods: {
    toggleIsOpen() {
      if (!this.isActive) return;

      this.$store.commit("draggable/setIsMenuOpen", !this.isOpen);
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-menu {
  bottom: 0;
  right: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  z-index: 10000;

  &__slot {
    background: transparent;
    border-radius: 3px 0 0 3px;
    bottom: 0;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    position: absolute;
    top: 38px;

    // fully hidden when closed
    right: -300px;
    width: 300px;
    transition: right 200ms ease-in-out;

    &.open {
      // slide into view, flush with the right edge
      right: 0;
    }
  }

  .btn {
    color: #393942;
    height: 24px;
    padding: 0;
    width: 24px;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      // pointer-events: none;
    }

    .custom-icon {
      display: flex;
    }
  }

  .toggle {
    align-items: center;
    background: #fff;
    border-radius: 3px 0 0 3px;
    display: flex;
    justify-content: center;
    height: 30px;
    margin: 4px 0;
    pointer-events: all;
    width: 30px;

    // Hover only when active
    &:has(.btn:not(.disabled)):hover {
      background: rgb(211, 210, 210);
      cursor: pointer; // active cursor
    }

    // When inactive (disabled)
    &:has(.btn.disabled) {
      cursor: not-allowed; // inactive cursor
    }
  }
}

::v-deep .tag-menu {
  background: #fff;
  padding: 15px;
  pointer-events: all;
  width: 100%;
  transition: all 300ms ease-in-out;
  z-index: 100;

  &__inner {
    display: flex;
    flex-direction: column;
    overflow: scroll;
    width: 100%;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 10px;
    text-align: center;
    width: 100%;
  }

  &__col {
    display: flex;
    flex-direction: column;
    margin: 0 0 5px 0;
    width: 100%;
  }

  &__block {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    label {
      font-size: 0.85em;
      margin: 0;
      text-transform: capitalize;
    }

    &--inline {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;

      input {
        width: calc(100% - 20px);
      }
    }
  }

  .inline-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 12px;

    label {
      margin: 0;
      font-size: 0.85em;
      flex: 1;
    }
  }

  .colour-controls {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-colour {
    border: 1px solid #111;
    border-radius: 3px;
    width: 44px;
    height: 22px;
  }

  .group-block__inputs {
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    input {
      width: 100%;
    }

    label {
      font-size: 0.75em;
      text-transform: none;
    }
  }

  .colour-eye-button {
    width: 32px;
    height: 22px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .colour-picker {
    margin-bottom: 10px;
    margin-top: 10px;
    width: 100%;
  }

  .buttons-row {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    width: 100%;
  }

  .btn-duplicate,
  .btn-remove {
    height: 36px;
    min-width: 100px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
  }

  /* Duplicate button */
  .btn-duplicate {
    background: #6f42c1;
    color: #fff;
    border: none;

    &:hover {
      background: #59359a;
      color: #fff;
    }
  }

  /* Remove button */
  .btn-remove {
    background: #d9534f;
    color: white;
    border: none;

    &:hover {
      background: #c9302c;
      color: #fff;
    }
  }
}
</style>
